import { render, staticRenderFns } from "./vipOrder.vue?vue&type=template&id=87d4724c&scoped=true&"
import script from "./vipOrder.vue?vue&type=script&lang=js&"
export * from "./vipOrder.vue?vue&type=script&lang=js&"
import style0 from "./vipOrder.vue?vue&type=style&index=0&id=87d4724c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d4724c",
  null
  
)

export default component.exports